namespace RioERP.Masters {
    export interface BooksRow {
        Id?: number;
        EBookType?: Web.Enums.EBookType;
        NoOfPages?: number;
        Cost?: number;
        TaxCategoryId?: number;
        IsActive?: boolean;
        BookName?: string;
        Isbn?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace BooksRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BookName';
        export const localTextPrefix = 'Masters.Books';
        export const lookupKey = 'Masters.Books';

        export function getLookup(): Q.Lookup<BooksRow> {
            return Q.getLookup<BooksRow>('Masters.Books');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            EBookType = "EBookType",
            NoOfPages = "NoOfPages",
            Cost = "Cost",
            TaxCategoryId = "TaxCategoryId",
            IsActive = "IsActive",
            BookName = "BookName",
            Isbn = "Isbn",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
